import { Link } from 'react-router-dom';
import { useState } from 'react';

// Placeholder images from Unsplash
const heroBg = "https://images.unsplash.com/photo-1469474968028-56623f02e42e";
const feature1 = "https://images.unsplash.com/photo-1488646953014-85cb44e25828";
const feature2 = "https://images.unsplash.com/photo-1524850011238-e3d235c7d4c9";
const feature3 = "https://images.unsplash.com/photo-1522199755839-a2bacb67c546";

export default function LandingPage() {
  const [showContact, setShowContact] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation Header */}
      <header className="absolute w-full z-50">
        <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            <div className="flex-shrink-0">
              <Link to="/" className="flex items-center">
                <span className="text-3xl font-bold text-white">
                  VacayPlanner
                </span>
              </Link>
            </div>
          </div>
        </nav>
      </header>

      {/* Hero Section */}
      <div 
        className="relative h-screen flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${heroBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-7xl font-bold text-white mb-8">
            VacayPlanner
          </h1>
          <h2 className="text-5xl font-bold text-white mb-6">
            Plan Your Perfect Trip
          </h2>
          <p className="text-xl text-white mb-8">
            Create detailed itineraries, manage destinations, and explore with ease
          </p>
          <div className="space-x-4">
            <Link
              to="/signup"
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-full text-white bg-blue-600 hover:bg-blue-700 transition-colors duration-300"
            >
              Get Started
            </Link>
            <Link
              to="/login"
              className="inline-flex items-center px-6 py-3 border-2 border-white text-base font-medium rounded-full text-white hover:bg-white hover:text-gray-900 transition-colors duration-300"
            >
              Log In
            </Link>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900">
              Everything you need for the perfect trip
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {/* Feature 1 */}
            <div className="rounded-xl overflow-hidden shadow-lg bg-white hover:shadow-xl transition-shadow duration-300">
              <img src={feature1} alt="Trip Planning" className="w-full h-48 object-cover" />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Smart Trip Planning
                </h3>
                <p className="text-gray-600">
                  Create detailed itineraries with our intuitive planning tools
                </p>
              </div>
            </div>

            {/* Feature 2 */}
            <div className="rounded-xl overflow-hidden shadow-lg bg-white hover:shadow-xl transition-shadow duration-300">
              <img src={feature2} alt="Map Integration" className="w-full h-48 object-cover" />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Interactive Maps
                </h3>
                <p className="text-gray-600">
                  Visualize your route and manage destinations easily
                </p>
              </div>
            </div>

            {/* Feature 3 */}
            <div className="rounded-xl overflow-hidden shadow-lg bg-white hover:shadow-xl transition-shadow duration-300">
              <img src={feature3} alt="Itinerary Management" className="w-full h-48 object-cover" />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Smart Itineraries
                </h3>
                <p className="text-gray-600">
                  Auto-generated suggestions for your perfect trip
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Call to Action with Footer Sections */}
      <div className="bg-blue-600 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 text-white items-start">
            {/* About Us Section */}
            <div className="md:col-span-3">
              <h3 className="text-xl font-bold mb-4">About Us</h3>
              <p className="text-sm">
                VacayPlanner is your ultimate travel companion, helping travelers create 
                memorable journeys through smart itinerary planning and destination 
                management. We make travel planning simple and enjoyable.
              </p>
              <p className="text-base font-bold mt-8 opacity-90">© 2025 VacayPlanner Inc. Privacy Terms and Conditions</p>
            </div>

            {/* Quick Links Section */}
            <div className="md:col-span-2">
              <h3 className="text-xl font-bold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li>
                  <button 
                    onClick={() => setShowContact(true)} 
                    className="text-sm hover:text-gray-200"
                  >
                    Contact Us
                  </button>
                </li>
              </ul>
            </div>

            {/* Start Planning Section */}
            <div className="md:col-span-4">
              <h3 className="text-xl font-bold mb-4">
                Start Planning Your Next Adventure
              </h3>
              <Link
                to="/signup"
                className="inline-flex items-center px-6 py-2 border-2 border-white text-sm font-medium rounded-full text-white hover:bg-white hover:text-blue-600 transition-colors duration-300"
              >
                Get Started - It's Free
              </Link>
            </div>

            {/* Contact Info Section */}
            <div className="md:col-span-3">
              <h3 className="text-xl font-bold mb-4">Contact Info</h3>
              <ul className="space-y-2 text-sm">
                <li>Email: deekundu15@gmail.com</li>
                <li>Phone: 0000000000</li>
                <li>Address: India</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Form Popup */}
      {showContact && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-8 max-w-md w-full m-4 relative">
            <button 
              onClick={() => setShowContact(false)}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Contact Us</h3>
            
            <form className="space-y-4">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
              
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
              
              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
                  Phone Number
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
              
              <button
                type="submit"
                className="w-full px-6 py-3 border border-transparent text-base font-medium rounded-full text-white bg-blue-600 hover:bg-blue-700 transition-colors duration-300"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}